import React, { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PasswordInput.css';

type PasswordInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

export default function PasswordInput({ id, style = {}, ...props }: PasswordInputProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const label = t(visible ? 'common.hidePassword' : 'common.showPassword');
  const { width = '100%', margin, marginTop, marginRight, marginBottom, marginLeft, ...inputStyle } = style;

  return (
    <div className="password-input" style={{ width, margin, marginTop, marginRight, marginBottom, marginLeft }}>
      <input
        {...props}
        id={inputId}
        type={visible ? 'text' : 'password'}
        aria-label={props['aria-label'] ?? props.placeholder}
        style={{ ...inputStyle, width: '100%', boxSizing: 'border-box', paddingRight: 48 }}
      />
      <button
        className="password-input__toggle"
        type="button"
        disabled={props.disabled}
        aria-label={label}
        title={label}
        aria-controls={inputId}
        aria-pressed={visible}
        onMouseDown={event => event.preventDefault()}
        onClick={() => setVisible(value => !value)}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
          <circle cx="12" cy="12" r="3" />
          {visible && <path d="m3 3 18 18" />}
        </svg>
      </button>
    </div>
  );
}
